import { computed } from 'vue';
import { getPlatform } from '@/utils/misc';

// Platform-specific visibility checks for Menu component
export function useMenuPlatformChecks() {
  const platform = computed(() => getPlatform());
  const isDesktopWeb = computed(() => platform.value === 'desktop-web');
  const isMobileWeb = computed(() => platform.value === 'mobile-web');
  const isNative = computed(() => !isDesktopWeb.value && !isMobileWeb.value);
  const showLogo = computed(() => !isMobileWeb.value);
  const showDeviceButton = computed(() => isNative.value);
  const showSwitchAccount = computed(() => !isMobileWeb.value);
  const showNetworkStatus = computed(() => isNative.value);
  const showFunctionButton = computed(() => isNative.value);
  const showWideAccountButton = computed(() => isDesktopWeb.value);

  return {
    platform,
    isDesktopWeb,
    isMobileWeb,
    isNative,
    showLogo,
    showDeviceButton,
    showSwitchAccount,
    showNetworkStatus,
    showFunctionButton,
    showWideAccountButton,
  };
}
